export function detectOSChatbot() {
  const userAgent = window.navigator.userAgent;
  let os;
  
  if (userAgent.includes("Android")) {
    os = "android";
  } else if (/iPhone|iPad|iPod/.test(userAgent)) {
    os = "ios";
  } else if (userAgent.includes("Windows NT")) {
    os = "windows";
  }else if (userAgent.includes("Mac OS X")) {
    os = "mac";
  } else if (userAgent.includes("Linux")) {
    os = "linux";
  } else {
    os = "unknown";
  }
  
  return os
}
